// Module
var code = `<section class="page-body default-content">

  <h2>Inputs</h2>
  <p>
    Inputs are used for single-line text entry such as names, emails, or passwords.
    SpyneJS styles inputs with consistent spacing, border radius, and typography,
    while providing clear focus and validation states.
  </p>

  <!-- Default Input -->
  <h3>Default Input</h3>
  <p>Basic text input with a label.</p>
  <div class="form-examples">
    <label for="input-default">Label</label>
    <input id="input-default" type="text" placeholder="Enter text" />
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="input-default"&gt;Label&lt;/label&gt;
&lt;input id="input-default" type="text" placeholder="Enter text" /&gt;
    </code></pre>
  </div>

  <!-- Focus State -->
  <h3>Focus State</h3>
  <p>
    On focus, inputs highlight the border and show a subtle
    <code>box-shadow</code> focus ring using the <code>--brand</code> token.
  </p>
  <div class="form-examples">
    <label for="input-focus">Focused</label>
    <input id="input-focus" type="text" value="Focus me" />
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="input-focus"&gt;Focused&lt;/label&gt;
&lt;input id="input-focus" type="text" value="Focus me" /&gt;
    </code></pre>
  </div>

  <!-- Disabled State -->
  <h3>Disabled Input</h3>
  <p>
    Disabled inputs use muted background and text colors, and cannot be interacted with.
  </p>
  <div class="form-examples">
    <label for="input-disabled">Disabled</label>
    <input id="input-disabled" type="text" placeholder="Disabled" disabled />
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="input-disabled"&gt;Disabled&lt;/label&gt;
&lt;input id="input-disabled" type="text" placeholder="Disabled" disabled /&gt;
    </code></pre>
  </div>

  <!-- Validation -->
  <h3>Validation States</h3>
  <p>
    Inputs can show validation states by applying semantic classes
    (<code>.success</code>, <code>.error</code>, <code>.warning</code>).
    These use <code>--success</code>, <code>--danger</code>, and
    <code>--warning</code> tokens for border and focus colors.
  </p>
  <div class="form-examples">
    <div>
      <label for="input-success">Success</label>
      <input id="input-success" type="text" value="Looks good" class="success" />
    </div>
    <div>
      <label for="input-error">Error</label>
      <input id="input-error" type="text" value="Invalid input" class="error" />
    </div>
  </div>
  <div class="codeblock">
    <div class="codeblock__header">
      <button class="codeblock__copy" data-copy-btn>Copy</button>
    </div>
    <pre><code class="language-html">
&lt;label for="input-success"&gt;Success&lt;/label&gt;
&lt;input id="input-success" type="text" value="Looks good" class="success" /&gt;

&lt;label for="input-error"&gt;Error&lt;/label&gt;
&lt;input id="input-error" type="text" value="Invalid input" class="error" /&gt;
    </code></pre>
  </div>

  <!-- Accessibility -->
  <h3>Accessibility</h3>
  <ul>
    <li>Always use <code>&lt;label&gt;</code> associated with inputs via <code>for</code> and <code>id</code>.</li>
    <li>Use semantic input types (<code>email</code>, <code>password</code>, <code>number</code>) for better keyboard and validation support.</li>
    <li>Ensure focus rings remain visible for keyboard navigation.</li>
    <li>Provide clear error messaging linked with <code>aria-describedby</code> when possible.</li>
  </ul>

  <!-- Navigation Back -->
  <p>
    <a class="route-link" data-channel="ROUTE"
       data-page-id="elements" data-topic-id="forms" data-option-id=""
       href="/elements/forms">← Back to Forms Overview</a>
  </p>

</section>
`;
// Exports
module.exports = code;